import { useState, useEffect, useCallback } from 'react';
import { maquinariaService } from '../services/supabase';

export function useMaquinarias(usuarioId, campoId) {
  const [maquinarias, setMaquinarias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadMaquinarias = useCallback(async () => {
    if (!usuarioId || !campoId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await maquinariaService.getAll(usuarioId, campoId);
      setMaquinarias(data || []);
    } catch (e) {
      setError(e.message);
      console.error('Error cargando maquinarias:', e);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, campoId]);

  useEffect(() => {
    loadMaquinarias();
  }, [loadMaquinarias]);

  const createMaquinaria = useCallback(async (maquinaria) => {
    if (!usuarioId || !campoId) throw new Error("usuarioId y campoId requeridos");
    try {
      const saved = await maquinariaService.create(usuarioId, campoId, maquinaria);
      setMaquinarias(prev => [...prev, saved]);
      return saved;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, [usuarioId, campoId]);

  const updateMaquinaria = useCallback(async (maquinariaId, updates) => {
    try {
      const updated = await maquinariaService.update(maquinariaId, updates);
      setMaquinarias(prev => prev.map(m => m.id === maquinariaId ? updated : m));
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  const deleteMaquinaria = useCallback(async (maquinariaId) => {
    try {
      await maquinariaService.delete(maquinariaId);
      setMaquinarias(prev => prev.filter(m => m.id !== maquinariaId));
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  return {
    maquinarias,
    setMaquinarias,
    loading,
    error,
    loadMaquinarias,
    createMaquinaria,
    updateMaquinaria,
    deleteMaquinaria,
  };
}
